import { useContext } from 'react';

import { LayerContext } from 'state/LayerContext';
import { useAppDispatch, useAppSelector } from 'state/hooks';
import {
  selectAnalysisEndDate,
  selectAnalysisName,
  selectAnalysisSegments,
  selectAnalysisStartDate,
  selectDayTypeSetting,
  selectIncludeMtr,
  selectTimePeriod,
  setAnalysisIsSaving,
  useCreateAnalysisMutation,
} from 'state/originDestinationSlices';
import { selectProject } from 'state/workflowSlice';

import StlCreatePopup from 'features/common/StlCreatePopup/StlCreatePopup';

import { useODUIMode } from './hooks/useODUIMode';

interface IODCreatePopup {
  open: boolean;
  setOpen: (v: boolean) => void;
}

export default function ODCreatePopup({ open, setOpen }: IODCreatePopup) {
  const dispatch = useAppDispatch();

  const project_slug = useAppSelector(selectProject);
  const segments = useAppSelector(selectAnalysisSegments);
  const analysisStart = useAppSelector(selectAnalysisStartDate);
  const analysisEnd = useAppSelector(selectAnalysisEndDate);
  const dayType = useAppSelector(selectDayTypeSetting);
  const name = useAppSelector(selectAnalysisName);
  const timePeriod = useAppSelector(selectTimePeriod);
  const includeMtr = useAppSelector(selectIncludeMtr);

  const [createAnalysis] = useCreateAnalysisMutation();
  const { setViewMode } = useODUIMode();
  const { layer } = useContext(LayerContext);

  const handleApply = async () => {
    try {
      dispatch(setAnalysisIsSaving(true));
      await createAnalysis({
        analysis: {
          name,
          day_type_setting: dayType,
          time_period: timePeriod,
          start_date: analysisStart,
          end_date: analysisEnd,
          tt_seg_ids: segments.map((el) => el.id),
          segment_display_names: segments.map((el) => el.name),
          layer,
          include_mtr: includeMtr,
        },
        project_slug,
      })
        .unwrap()
        .then((res) => {
          setViewMode(res);
          dispatch(setAnalysisIsSaving(false));
        });
    } catch (e) {
      dispatch(setAnalysisIsSaving(false));
      console.error('Analysis creation failed', e);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <StlCreatePopup
      open={open}
      itemName="analysis"
      itemNamePlural="analyses"
      handleApply={handleApply}
      handleClose={handleClose}
      timeLabel="few hours"
    />
  );
}
